var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 510 510"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff5d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce47"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__k",
    x1: 228.956,
    x2: 388.026,
    y1: 5.345,
    y2: 164.415,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__a"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6fa953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__l",
    x1: 45.058,
    x2: 116.259,
    y1: 165.361,
    y2: 236.562,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__b"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e08e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fa953"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__m",
    x1: 161.177,
    x2: 254.747,
    y1: 40.873,
    y2: 134.444,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__c"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__n",
    x1: 331.832,
    x2: 483.7,
    y1: 108.221,
    y2: 260.09,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__d"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff755c"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__o",
    x1: 365.57,
    x2: 453.611,
    y1: 245.266,
    y2: 333.308,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__e"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45a2e0"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__p",
    x1: 32.372,
    x2: 135.969,
    y1: 255.983,
    y2: 359.58,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__f"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__q",
    x1: 254.831,
    x2: 341.741,
    y1: 375.135,
    y2: 462.044,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__g"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843561"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__r",
    x1: 106.478,
    x2: 316.633,
    y1: 330.088,
    y2: 540.244,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__h"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__s",
    x1: 351.073,
    x2: 253.172,
    y1: 168.534,
    y2: 70.633,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__a"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__t",
    x1: 157.639,
    x2: 36.299,
    y1: 248.897,
    y2: 127.557,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__b"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__u",
    x1: 242.503,
    x2: 134.517,
    y1: 151.245,
    y2: 43.259,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__c"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__v",
    x1: 436.365,
    x2: 322.367,
    y1: 253.826,
    y2: 139.828,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__d"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__w",
    x1: 428.506,
    x2: 352.346,
    y1: 337.248,
    y2: 261.088,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__e"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__x",
    x1: 187.562,
    x2: 46.948,
    y1: 370.101,
    y2: 229.487,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__f"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__y",
    x1: 341.317,
    x2: 238.827,
    y1: 432.575,
    y2: 330.085,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__g"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__z",
    x1: 257.313,
    x2: 132.233,
    y1: 439.852,
    y2: 314.772,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__h"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__A",
    x1: 358.303,
    x2: 285.612,
    y1: 358.303,
    y2: 285.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2f4d"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__B",
    x1: 145.995,
    x2: 292.43,
    y1: 1431.997,
    y2: 1431.997,
    gradientTransform: "rotate(45 1331.838 751.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc0d5"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__C",
    x1: 51.915,
    x2: 334.839,
    y1: 316.624,
    y2: 316.624,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__d"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__D",
    x1: 232.818,
    x2: 128.289,
    y1: 363.109,
    y2: 258.58,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__d"
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__i"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f73a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__E",
    x1: 214.792,
    x2: 252.156,
    y1: 1499.633,
    y2: 1499.633,
    gradientTransform: "rotate(45 1331.838 751.37)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__i"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__j"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__F",
    x1: 46.988,
    x2: 72.469,
    y1: 569.7,
    y2: 575.898,
    gradientTransform: "rotate(45 787.19 716.911)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__j"
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__G",
    x1: 101.952,
    x2: 138.451,
    y1: 575.692,
    y2: 586.022,
    gradientTransform: "rotate(45 787.19 716.911)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__j"
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__H",
    x1: 111.013,
    x2: 66.075,
    y1: 535.308,
    y2: 535.308,
    gradientTransform: "rotate(45 787.19 716.911)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__i"
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__I",
    x1: 84.136,
    x2: 84.136,
    y1: 678.695,
    y2: 703.245,
    gradientTransform: "rotate(45 787.19 716.911)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphics_svg__J",
    x1: 79.049,
    x2: 90.631,
    y1: 719.619,
    y2: 769.419,
    gradientTransform: "rotate(45 787.19 716.911)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#graphics_svg__i"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__k)",
    d: "M425.135 84.865l-94.513 94.513c-19.356-19.356-46.094-31.33-75.622-31.33V14.393c66.438 0 126.598 26.924 170.135 70.472z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__l)",
    d: "M179.378 179.378c-19.356 19.356-31.33 46.094-31.33 75.622H14.393c0-66.438 26.924-126.598 70.472-170.135z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__m)",
    d: "M255 14.393v133.655c-29.528 0-56.266 11.974-75.622 31.33L84.865 84.865C128.402 41.317 188.562 14.393 255 14.393z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__n)",
    d: "M495.607 255H361.952c0-29.528-11.974-56.266-31.33-75.622l94.513-94.513c43.548 43.537 70.472 103.697 70.472 170.135z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__o)",
    d: "M495.607 255c0 66.438-26.924 126.598-70.472 170.135l-94.513-94.513c19.356-19.356 31.33-46.094 31.33-75.622z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__p)",
    d: "M179.378 330.622l-94.513 94.513C41.317 381.598 14.393 321.438 14.393 255h133.655c0 29.528 11.974 56.266 31.33 75.622z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__q)",
    d: "M425.135 425.135C381.598 468.683 321.438 495.607 255 495.607V361.952c29.528 0 56.266-11.974 75.622-31.33z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__r)",
    d: "M255 361.952v133.655c-66.438 0-126.598-26.924-170.135-70.472l94.513-94.513c19.356 19.356 46.094 31.33 75.622 31.33z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__s)",
    d: "M384.063 125.937l-53.441 53.441c-19.356-19.356-46.094-31.33-75.622-31.33V72.484c50.407 0 96.024 20.426 129.063 53.453z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__t)",
    d: "M179.378 179.378c-19.356 19.356-31.33 46.094-31.33 75.622H72.484c0-50.407 20.425-96.024 53.453-129.063z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__u)",
    d: "M255 72.484v75.564c-29.528 0-56.266 11.974-75.622 31.33l-53.441-53.441C158.976 92.91 204.593 72.484 255 72.484z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__v)",
    d: "M437.516 255h-75.564c0-29.528-11.974-56.266-31.33-75.622l53.441-53.441c33.027 33.039 53.453 78.656 53.453 129.063z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__w)",
    d: "M437.516 255c0 50.407-20.426 96.024-53.453 129.063l-53.441-53.441c19.356-19.356 31.33-46.094 31.33-75.622z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__x)",
    d: "M179.378 330.622l-53.441 53.441C92.91 351.024 72.484 305.407 72.484 255h75.564c0 29.528 11.974 56.266 31.33 75.622z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__y)",
    d: "M384.063 384.063C351.024 417.09 305.407 437.516 255 437.516v-75.564c29.528 0 56.266-11.974 75.622-31.33z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__z)",
    d: "M255 361.952v75.564c-50.407 0-96.024-20.426-129.063-53.453l53.441-53.441c19.356 19.356 46.094 31.33 75.622 31.33z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__A)",
    d: "M452.919 118.166l-98.176 98.176c4.652 11.991 7.209 25.025 7.209 38.657 0 29.528-11.974 56.266-31.33 75.622s-46.094 31.33-75.622 31.33c-13.632 0-26.667-2.557-38.657-7.209l-98.176 98.176c38.85 26.911 85.999 42.688 136.834 42.688 66.438 0 126.598-26.924 170.135-70.472 43.548-43.536 70.472-103.697 70.472-170.135-.001-50.834-15.778-97.983-42.689-136.833z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__B)",
    d: "M51.914 354.541L.528 498.286c-2.486 6.955 4.23 13.672 11.185 11.186l143.745-51.386c28.679-28.679-74.866-132.223-103.544-103.545z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__C)",
    d: "M328.986 284.574l-173.53 173.512c-2.835-4.913-7.143-9.26-12.662-12.34-7.54-4.176-19.332-1.89-27.496.586-1.777.529-3.402-.397-4.063-1.814a3.4 3.4 0 01-.038-2.91c.019 0 .019-.019.019-.019a33.478 33.478 0 001.191-3.156l.454-1.531c.019-.038.019-.057.019-.094.435-1.644.737-3.288.907-4.97.057-.548.095-1.115.132-1.663.047-.913.056-1.826.026-2.739a32.298 32.298 0 00-6.263-18.124 31.878 31.878 0 00-3.231-3.761 31.794 31.794 0 00-3.761-3.232c-6.161-4.535-13.569-6.614-20.863-6.236-.548.038-1.115.076-1.663.132-1.682.17-3.345.472-4.97.907-.038 0-.057 0-.095.019l-1.531.454c-.548.17-1.077.359-1.606.567-.51.189-1.021.397-1.531.624-.019 0-.019 0-.038.019a3.396 3.396 0 01-2.91-.038c-1.417-.661-2.343-2.287-1.814-4.063 2.476-8.164 4.762-19.937.586-27.477-3.081-5.537-7.408-9.846-12.34-12.68l173.512-173.53c7.823-7.805 20.485-7.805 28.29 0l14.759 14.759 45.751 45.751 14.759 14.759c7.804 7.803 7.804 20.464 0 28.288z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__D)",
    d: "M314.227 241.525L111.235 444.517a3.4 3.4 0 01-.038-2.91c.019 0 .019-.019.019-.019.454-1.039 2.419-8.088 2.57-9.751.076-.567.113-1.115.132-1.663.378-7.294-1.701-14.702-6.236-20.863a31.878 31.878 0 00-3.231-3.761 31.794 31.794 0 00-3.761-3.232c-6.161-4.535-13.569-6.614-20.863-6.236-.548.019-1.096.057-1.663.132a28.367 28.367 0 00-4.97.907c-.038 0-.057 0-.095.019-.51.132-4.157 1.417-4.668 1.644-.019 0-.019 0-.038.019a3.396 3.396 0 01-2.91-.038l202.992-202.992z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__E)",
    d: "M29.544 480.456a72.08 72.08 0 00-17.951-13.121L.529 498.286c-2.486 6.955 4.23 13.672 11.185 11.185l30.951-11.064a72.044 72.044 0 00-13.121-17.951z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__F)",
    d: "M493.814 16.187L284.279 225.722l-30.651-30.651c-6.681-6.681-6.681-17.514 0-24.195l18.332-18.332a42.193 42.193 0 0012.358-29.835V99.864c0-17.973 11.385-33.973 28.366-39.863L484.029.567c9.486-3.291 16.884 8.52 9.785 15.62z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__G)",
    d: "M493.814 16.187L284.279 225.722l30.651 30.651c6.681 6.681 17.514 6.681 24.195 0l18.332-18.332a42.193 42.193 0 0129.835-12.358h22.844c17.973 0 33.973-11.385 39.863-28.366l59.434-171.346c3.291-9.485-8.52-16.884-15.619-9.784z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__H)",
    d: "M395.093 124.746L500.341 19.498c2.62-2.62 2.931-6.885.485-9.669a6.958 6.958 0 00-10.156-.338L385.5 114.662c-6.886 6.886-16.428 10.656-26.129 9.799-8.973-.792-18.245 2.605-24.642 10.195-9.065 10.755-8.921 26.797.316 37.405 11.09 12.736 30.43 13.235 42.167 1.498 6.147-6.147 8.935-14.378 8.369-22.417-.692-9.795 2.569-19.453 9.512-26.396z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__I)",
    d: "M282.54 134.813a42.202 42.202 0 01-10.58 17.73l-18.332 18.332c-6.681 6.681-6.681 17.514 0 24.195l30.651 30.651 30.651 30.651c6.681 6.681 17.514 6.681 24.195 0l18.332-18.332a42.181 42.181 0 0117.73-10.58z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#graphics_svg__J)",
    d: "M303.325 310.235l-103.559-103.56 41.271-41.271c4.78-4.78 12.529-4.78 17.308 0l86.251 86.251c4.78 4.78 4.78 12.529 0 17.308z"
  })));
}
export default __webpack_public_path__ + "static/graphics.81264ed4.svg";
export { SvgGraphics as ReactComponent };